import { render, staticRenderFns } from "./ModalTransferir.vue?vue&type=template&id=d5326ef2&scoped=true&"
import script from "./ModalTransferir.vue?vue&type=script&lang=js&"
export * from "./ModalTransferir.vue?vue&type=script&lang=js&"
import style0 from "./ModalTransferir.vue?vue&type=style&index=0&id=d5326ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5326ef2",
  null
  
)

export default component.exports